import { render, staticRenderFns } from "./unLoaded copy.vue?vue&type=template&id=0cdbd01e&scoped=true"
import script from "./unLoaded copy.vue?vue&type=script&lang=js"
export * from "./unLoaded copy.vue?vue&type=script&lang=js"
import style0 from "./unLoaded copy.vue?vue&type=style&index=0&id=0cdbd01e&prod&scoped=true&lang=scss"
import style1 from "./unLoaded copy.vue?vue&type=style&index=1&id=0cdbd01e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbd01e",
  null
  
)

export default component.exports